import { mapGetters } from 'vuex';
import {
  FLOAT_DOWN_WORKFLOW,
  PRICER_UI_LOCK_DESK_WORKFLOWS,
  PRICER_UI_QA_IS_MOBILE,
  PRICER_UI_REDESIGN_FRONTEND,
  RENEGOTIATION_WORKFLOW,
} from '@shared/constants/flags';
import { DEFAULT_ROUTES } from '@pe/router';
import { getCookie } from '@shared/utils/cookies';

// frontend/src/pe/router/index.js
const LOAN_SCENARIOS_ROUTE_NAME = 'loan-scenarios';
const LOAN_PIPELINE_ROUTE_NAME = DEFAULT_ROUTES.loans;
const RATE_SHEETS_ROUTE_NAME = 'rate-sheets';
const LOAN_PRICING_ROUTE_NAME = 'loan-pricing';
const EMBEDDED_LOAN_SCENARIOS_ROUTE_NAME = 'loan-pricing-embed';
const EMBEDDED_LOAN_SCENARIOS_OPTIONS_ROUTE_NAME = 'loan-pricing-embed-options';
const RENEGOTIATION_ROUTE_NAME = 'renegotiation';
const FLOAT_DOWN_ROUTE_NAME = 'float-down';
const RATE_ALERTS_NAME = 'rate-alerts';

// List of old app routing names which we intend to redirect to the new app routes
// Ensure the defined old route includes meta field "newAppPath" (new app's path)
// this will allow us redirect to the new app route
// "newAppPath" implies /app
// e.g.) { [...], newAppPath: '/pe/new-loan-scenarios' }
// ends up being directed to '/app/pe/new-loan-scenarios'
const NEW_APP_REDIRECT_ROUTES = [
  LOAN_SCENARIOS_ROUTE_NAME,
  LOAN_PIPELINE_ROUTE_NAME,
  LOAN_PRICING_ROUTE_NAME,
  EMBEDDED_LOAN_SCENARIOS_ROUTE_NAME,
  EMBEDDED_LOAN_SCENARIOS_OPTIONS_ROUTE_NAME,
  RATE_ALERTS_NAME,
];

export default {
  data() {
    return {
      newAppLoading: false,
    };
  },
  computed: {
    ...mapGetters('core', [
      'isFlagActive',
      'organization',
      'isUserLockDeskOrHigher',
    ]),
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        // NOTE: SPECIAL CASE FOR PRICER UI REDESIGN
        // redirect to new app UI
        const defaultNewUI = getCookie('defaultNewUI');
        console.log('defaultNewUI', defaultNewUI);
        const isStaff = this.$store.getters['core/userInfo'].is_staff;
        console.log('isStaff', isStaff);
        // If user info is not loaded yet, return
        if (isStaff === undefined) {
          return;
        }

        const disableUIForcedRedirect = defaultNewUI === false && isStaff;
        console.log('disableUIForcedRedirect', disableUIForcedRedirect);
        console.log(
          'isFlagActive(PRICER_UI_REDESIGN_FRONTEND)',
          this.isFlagActive(PRICER_UI_REDESIGN_FRONTEND),
        );
        console.log('NEW_APP_REDIRECT_ROUTES.includes(to.name)', to.name);
        console.log(
          'this.isFlagActive(PRICER_UI_QA_IS_MOBILE) || this.isMobile',
          this.isFlagActive(PRICER_UI_QA_IS_MOBILE) || this.isMobile,
        );
        console.log(
          'this.canAccessNewUiWithoutFlag(to.name)',
          this.canAccessNewUiWithoutFlag(to.name),
        );

        if (
          (!disableUIForcedRedirect &&
            this.isFlagActive(PRICER_UI_REDESIGN_FRONTEND) &&
            NEW_APP_REDIRECT_ROUTES.includes(to.name) &&
            (this.isFlagActive(PRICER_UI_QA_IS_MOBILE) || this.isMobile)) ||
          this.canAccessNewUiWithoutFlag(to.name)
        ) {
          const { mode, type } = to.query;
          if (
            mode !== 'analysis' &&
            (mode !== 'lockDesk' ||
              (this.isFlagActive(PRICER_UI_LOCK_DESK_WORKFLOWS) &&
                this.isUserLockDeskOrHigher &&
                ['reprice', 'relock', 'productchange'].includes(
                  type.toLowerCase(),
                )))
          ) {
            this.newAppLoading = true;
            const toPath = to.meta?.newAppPath
              ? this.replaceUrlParameter(to.meta.newAppPath, to.params, mode)
              : to.path;

            let urlPath = import.meta.env.DEV
              ? 'http://localhost:8080'
              : '/app';
            // pass query params through
            urlPath += `${toPath}${location.search}`;

            location.replace(urlPath);
          }
        }
      },
    },
  },
  methods: {
    canAccessRateSheets(routeName) {
      return (
        this.organization.enable_custom_ratesheets &&
        routeName === RATE_SHEETS_ROUTE_NAME
      );
    },
    canAccessRenegotiation(routeName) {
      return (
        this.isFlagActive(RENEGOTIATION_WORKFLOW) &&
        routeName === RENEGOTIATION_ROUTE_NAME
      );
    },
    canAccessFloatDown(routeName) {
      return (
        this.isFlagActive(FLOAT_DOWN_WORKFLOW) &&
        routeName === FLOAT_DOWN_ROUTE_NAME
      );
    },
    canAccessNewUiWithoutFlag(routeName) {
      return (
        this.canAccessRateSheets(routeName) ||
        this.canAccessRenegotiation(routeName) ||
        this.canAccessFloatDown(routeName)
      );
    },
    replaceUrlParameter(url, params, mode) {
      return url.replace(/:(\w+)/g, (match, key) => {
        return params[key] !== undefined ? params[key] : match;
      });
    },
  },
};
